const BasicDataResources = {
    adminRoutes: 'admin-routes',
    applicationForms: 'application-forms',
    containerMaterials: 'container-materials',
    containerTypes: 'container-types',
    diagnoses: 'diagnoses',
    hazardClasses: 'hazard-classes',
    solutionTypes: 'solution-types',
    medicineForms: 'medicine-forms',
    cancerTypes: 'cancer-types',
    companies: 'companies',
    stockLocations: 'stock-locations',
    treatmentChairs: 'treatment-chairs',
    storageLabels: 'storage-labels',
    insuranceCompanies: 'insurance-companies',
    generalPhysicians: 'general-physicians',
};
import { Status } from './util/schemas.js';
export { ConsumablesBatchesSchema, DistributedBatchesListResponseSchema, ExtrasBatchesSchema, ListItemSchema, } from './util/schemas.js';
export { builder, schema, zql } from './zero-schema.gen.js';
export { BasicDataResources, Status };
export {} from './util/schemas.js';
export { DispatchMode } from './mutators/patients-therapies/state-machine.js';
//# sourceMappingURL=schema.js.map